module.exports = __webpack_public_path__ + "img/2024-02-13d_2.15e386ea.jpg";